var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9254 9.13064L9.30383 9.2365V2.65504V2.55504H9.20383H8.96572C7.01485 2.55504 5.24843 3.3411 3.96969 4.61187C2.69123 5.88237 1.9 7.63837 1.9 9.57737C1.9 11.5167 2.69123 13.2727 3.96968 14.5435L3.9697 14.5435C5.24843 15.8139 7.01485 16.6 8.96572 16.6C10.9166 16.6 12.6833 15.8139 13.9617 14.5435C15.2405 13.2727 16.0317 11.5167 16.0308 9.57733L16.0308 9.57627L16.027 9.22952L16.0259 9.12903L15.9254 9.13064ZM9.98821 8.36835L9.98782 8.46874H10.0882H17H17.1V8.36874C17.1 4.52961 13.9765 1.41485 10.1151 1.4L10.0151 1.39962L10.0147 1.49961L9.98821 8.36835ZM8.6276 3.23717V9.81693V9.91854L8.7292 9.91692L15.3511 9.8114C15.2905 11.4716 14.5889 12.9691 13.4842 14.0669C12.3279 15.216 10.7304 15.9267 8.96572 15.9267C7.20106 15.9267 5.60383 15.216 4.4475 14.0669C3.29119 12.9177 2.57623 11.3308 2.57623 9.57737C2.57623 7.82458 3.29119 6.23729 4.4475 5.08818C5.5296 4.01282 6.99781 3.32166 8.6276 3.23717Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportManagement);
export default __webpack_public_path__ + "static/media/report-management.7aae676e1ddedfa81adc677aacb1b571.svg";
export { ForwardRef as ReactComponent };